import { Select as SelectChakra, SelectProps } from '@chakra-ui/react';
import { FieldHelperProps, FieldInputProps, FieldMetaProps } from 'formik';
import React from 'react';

type TSelect = {
  id: string;
  name: string;
  field?: [FieldInputProps<any>, FieldMetaProps<any>, FieldHelperProps<any>];
} & SelectProps;

export default function Select({ field, children, ...rest }: TSelect) {
  const [fieldData] = field ?? [];

  return (
    <SelectChakra data-cy={`field-${rest.name}`} {...fieldData} {...rest}>
      {children}
    </SelectChakra>
  );
}
